import React, { useState } from 'react';
import LegalLayout from './LegalLayout';

const ComplaintsBook = () => {
  const [formData, setFormData] = useState({
    fullName: '',
    documentType: '',
    documentNumber: '',
    email: '',
    phone: '',
    complaintType: '',
    productService: '',
    purchaseDate: '',
    amount: '',
    complaintDetails: '',
    desiredSolution: ''
  });
  
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const [submitError, setSubmitError] = useState('');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // In a real application, this would send the data to a server
    console.log('Complaint submitted:', formData);
    setSubmitSuccess(true);
    setSubmitError('');
    
    // Reset form after successful submission
    setFormData({
      fullName: '',
      documentType: '',
      documentNumber: '',
      email: '',
      phone: '',
      complaintType: '',
      productService: '',
      purchaseDate: '',
      amount: '',
      complaintDetails: '',
      desiredSolution: ''
    });
    
    // Hide success message after 5 seconds
    setTimeout(() => {
      setSubmitSuccess(false);
    }, 5000);
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white py-12">
      <div className="container-standard px-4 max-w-4xl">
        <div className="bg-white rounded-2xl shadow-xl p-8 border border-gray-100">
            <div className="flex justify-center items-center mb-6">
              <a href="/" className="text-primary-accent font-bold hover:underline text-lg">
                 ← Volver al Inicio
              </a>
            </div>
          <div className="text-center mb-4">
            <h1 className="text-display font-bold text-primary-dark">Libro de Reclamaciones Virtual</h1>
          </div>
          <div className="text-center mb-8">
            <p className="text-xl text-gray-600">DAVID CORPORATION S.R.L. - DAVIDCORP S.R.L.</p>
            <p className="text-lg text-gray-600 mt-2">RUC: 20602434011</p>
          </div>
          
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
            <h3 className="text-lg font-semibold text-blue-800 mb-2">Información Importante</h3>
            <p className="text-sm text-blue-700">
              De conformidad con la Ley N° 29587, Ley de Protección al Consumidor, y su Reglamento aprobado por Decreto Supremo N° 002-2018-INDECOPI, 
              ponemos a su disposición el Libro de Reclamaciones Virtual para que pueda presentar sus quejas o reclamos de manera electrónica.
            </p>
          </div>
          
          {submitSuccess && (
            <div className="mb-6 p-4 bg-green-100 text-green-700 rounded-lg">
              ✓ ¡Su reclamo ha sido enviado correctamente! Nos pondremos en contacto con usted en los próximos días hábiles.
            </div>
          )}
          
          {submitError && (
            <div className="mb-6 p-4 bg-red-100 text-red-700 rounded-lg">
              {submitError}
            </div>
          )}
          
          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label htmlFor="fullName" className="block text-gray-700 font-medium mb-2">Nombres y Apellidos:</label>
                <input
                  type="text"
                  id="fullName"
                  name="fullName"
                  value={formData.fullName}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-accent focus:border-transparent outline-none transition"
                  placeholder="Ingrese su nombre completo"
                />
              </div>
              
              <div>
                <label htmlFor="documentType" className="block text-gray-700 font-medium mb-2">Tipo de Documento:</label>
                <select
                  id="documentType"
                  name="documentType"
                  value={formData.documentType}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-accent focus:border-transparent outline-none transition"
                >
                  <option value="">Seleccione...</option>
                  <option value="dni">DNI</option>
                  <option value="passport">Pasaporte</option>
                  <option value="ruc">RUC</option>
                  <option value="other">Otro</option>
                </select>
              </div>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label htmlFor="documentNumber" className="block text-gray-700 font-medium mb-2">Número de Documento:</label>
                <input
                  type="text"
                  id="documentNumber"
                  name="documentNumber"
                  value={formData.documentNumber}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-accent focus:border-transparent outline-none transition"
                  placeholder="Ingrese su número de documento"
                />
              </div>
              
              <div>
                <label htmlFor="email" className="block text-gray-700 font-medium mb-2">Correo Electrónico:</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-accent focus:border-transparent outline-none transition"
                  placeholder="correo@ejemplo.com"
                />
              </div>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label htmlFor="phone" className="block text-gray-700 font-medium mb-2">Teléfono:</label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-accent focus:border-transparent outline-none transition"
                  placeholder="(51) 999 999 999"
                />
              </div>
              
              <div>
                <label htmlFor="complaintType" className="block text-gray-700 font-medium mb-2">Tipo de Reclamo:</label>
                <select
                  id="complaintType"
                  name="complaintType"
                  value={formData.complaintType}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-accent focus:border-transparent outline-none transition"
                >
                  <option value="">Seleccione...</option>
                  <option value="quality">Calidad del Producto/Servicio</option>
                  <option value="delivery">Entrega</option>
                  <option value="billing">Facturación</option>
                  <option value="customer-service">Servicio al Cliente</option>
                  <option value="other">Otro</option>
                </select>
              </div>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label htmlFor="productService" className="block text-gray-700 font-medium mb-2">Producto o Servicio Adquirido:</label>
                <input
                  type="text"
                  id="productService"
                  name="productService"
                  value={formData.productService}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-accent focus:border-transparent outline-none transition"
                  placeholder="Describa el producto o servicio"
                />
              </div>
              
              <div>
                <label htmlFor="purchaseDate" className="block text-gray-700 font-medium mb-2">Fecha de Adquisición:</label>
                <input
                  type="date"
                  id="purchaseDate"
                  name="purchaseDate"
                  value={formData.purchaseDate}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-accent focus:border-transparent outline-none transition"
                />
              </div>
            </div>
            
            <div>
              <label htmlFor="amount" className="block text-gray-700 font-medium mb-2">Importe del Producto o Servicio:</label>
              <input
                type="number"
                id="amount"
                name="amount"
                value={formData.amount}
                onChange={handleChange}
                step="0.01"
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-accent focus:border-transparent outline-none transition"
                placeholder="0.00"
              />
            </div>
            
            <div>
              <label htmlFor="complaintDetails" className="block text-gray-700 font-medium mb-2">Detalle del Reclamo:</label>
              <textarea
                id="complaintDetails"
                name="complaintDetails"
                value={formData.complaintDetails}
                onChange={handleChange}
                required
                rows={5}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-accent focus:border-transparent outline-none transition"
                placeholder="Por favor, detallar su reclamo..."
              ></textarea>
            </div>
            
            <div>
              <label htmlFor="desiredSolution" className="block text-gray-700 font-medium mb-2">Solución Deseada:</label>
              <textarea
                id="desiredSolution"
                name="desiredSolution"
                value={formData.desiredSolution}
                onChange={handleChange}
                rows={3}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-accent focus:border-transparent outline-none transition"
                placeholder="¿Qué solución espera obtener?"
              ></textarea>
            </div>
            
            <div className="text-center">
              <button
                type="submit"
                className="bg-primary-dark hover:bg-[#0d1c32] text-white font-semibold py-4 px-8 rounded-lg transition duration-300 transform hover:scale-105 shadow-lg"
              >
                Enviar Reclamo
              </button>
            </div>
          </form>
          
          <div className="mt-8 pt-6 border-t border-gray-200">
            <h3 className="text-lg font-semibold text-gray-800 mb-3">Derechos del Consumidor</h3>
            <ul className="text-sm text-gray-600 space-y-1">
              <li>• Derecho a la protección de la vida, salud e integridad física</li>
              <li>• Derecho a la información veraz, clara y oportuna</li>
              <li>• Derecho a la libertad de elección y a la equidad</li>
              <li>• Derecho a la educación para el consumo</li>
              <li>• Derecho a la protección contractual</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ComplaintsBook;